"use client";

import { cn } from '@/lib/utils';
import { MoveLeft } from 'lucide-react';
import React from 'react'

const BackButton = () => {
    return (
        <button
            onClick={() => window.history.back()}
            className={cn(
                `md:ml-6 cursor-pointer text-secondary-red
                hover:-translate-x-1.5
                hover:transition-transform hover:duration-300 duration-300
                `
            )}>
            <MoveLeft />
        </button>
    )
}

export default BackButton